module.exports = __webpack_public_path__ + "static/media/11.8b5d882c.svg";